// Core
import React from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


// logo
import Logo from 'assets/images/logo.webp'

// Styles
import './styles.scss';
import { useSelector } from 'react-redux';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer = () => {
  const { userDetails, currentLang } = useSelector((store) => store.commonData);
  const { t } = useTranslation();

  return (
    <div className='container'>
      <div className='__footer'>
      <p>© 2023 | Sheikhaart | All rights reserved</p>
      <a href="https://www.instagram.com/sheikhaart/" target='_blank' style={{color:'#000'}}><InstagramIcon sx={{fontSize:40}}/></a>
    </div>
    </div>
  );

};

export default Footer;
